import { Button, Stack, VStack } from "@chakra-ui/react";
import { useGetPayByIdQuery } from "apis";
import { ActionBar, Layout, PageMotion, PoweredBy, TransactionDetailItem } from "components";
import { PageProps } from "interfaces";
import { useNavigate, useParams } from "react-router";
import { readableStatus, transferStatusColor } from "utils";

export interface TransactionProps extends PageProps {}

const PayReference = (props: TransactionProps) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data, isLoading } = useGetPayByIdQuery(id!);

  const handleClose = () => {
    navigate("/cico", { replace: true });
  };

  return (
    <PageMotion key="Transaction" px="4px">
      <Layout>
        <ActionBar onBackClick={handleClose} title="Transaction Details" />

        {!isLoading && (
          <Stack my="34px !important" px="3px" sx={{ "> *": { mt: "0 !important" } }}>
            <TransactionDetailItem
              title="Amount Received"
              description={`${Number(data?.amount).toLocaleString()} ${String(data?.unit).toUpperCase()}`}
            />

            <TransactionDetailItem
              title="Fee"
              description={`${Number(data?.fee).toLocaleString()} ${String(data?.unit).toUpperCase()}`}
            />

            <TransactionDetailItem
              _description={{ color: transferStatusColor(data?.paymentStatus!), textTransform: "capitalize" }}
              title="Transaction Status"
              description={readableStatus(data?.paymentStatus!)}
            />

            <TransactionDetailItem title="Payment Reference" description={data?.reference} isCopyable />

            <TransactionDetailItem title="Transaction Id" description={data?.transactionId} isCopyable />

            <TransactionDetailItem title="Payment Id" description={data?.paymentId} isCopyable />

            <VStack mt="46px !important">
              <Button variant="transparent" w="100%" fontWeight="500" textDecoration="underline" onClick={handleClose}>
                Close
              </Button>
            </VStack>
          </Stack>
        )}
      </Layout>

      <PoweredBy />
    </PageMotion>
  );
};

export default PayReference;
